import {getClient} from "./axiosClient";

const client = getClient()


async function* fetchPages(url, startPage, params, dataExtractor, signal) {
    let lastPage = 0;
    let currentPage = startPage;

    do {
        const parameters = params ? { ...params, page: currentPage } : { page: currentPage };

        try {
            let response = await client.get(url, { params: parameters, signal });
            yield dataExtractor(response.data);

            currentPage++;
            lastPage = response.data.lastPage;
        }
        catch (error) {
            if (signal?.aborted) {
                break; // Exit the loop when aborted
            }
            throw error; // Rethrow other errors
        }

    } while (currentPage <= lastPage);
}

export async function* fetchDataFromAllPages(url, startPage = 0, params = null, signal = null) {
    yield* fetchPages(url, startPage, params, (data) => data.data, signal);
}

export async function* loadAllPages(url, startPage = 0, params = null, signal = null) {
    yield* fetchPages(url, startPage, params, (data) => data, signal);
}


export async function getCompany(id)
{
    const response = await client.get(`v1/company/${id}`, { timeout: 30_000 })
    return response;
}

export async function getAllCompanies()
{
    return await client.get('v1/company');
}

export async function getAllBundles(companyId, includeInactive)
{
    return await client.get(`/v1/billing/bundles/company/${companyId}?includeInactive=${includeInactive}`);
}

export async function getBundlesForCompany(id)
{
    return await client.get(`v1/billing/bundles/company/${id}`);
}

export async function bundleOperationsForCompany(id, bundles) 
{
  return await client.put(`v1/billing/bundles/company/${id}`, bundles);
}

export async function getBalanceForCompany(id, signal = null)
{
    return await client.get(`v1/billing/balance/company/${id}`, { signal });
}

export async function topUpCompanyBalance(companyId, bundleId, info)
{
      return await client.post(`v1/billing/balance/company/${companyId}/bundle/${bundleId}`, info);;
}

export async function updateBundlesForCompany(companyId, bundles)
{
      return await client.put(`v1/billing/bundles/company/${companyId}`, bundles);;
}

export async function getBundlePurchases(companyId, range)
{
      return await client.get(`v1/billing/report/purchases/company/${companyId}?range=${range}`);;
}

export async function getManualAdjustments(companyId, range)
{
      return await client.get(`v1/billing/report/adjustments/company/${companyId}?range=${range}`);;
}

export async function getBalanceHistory(companyId, range)
{
      return await client.get(`v1/billing/report/balance/company/${companyId}?range=${range}`);;
}

export async function getCompanyConsumption(companyId, range)
{
      return await client.get(`v1/billing/report/consumption/company/${companyId}?range=${range}`);;
}

export async function getConsumptionForMsisdn(companyId, range, msisdnQuery)
{
      return await client.get(`v1/billing/report/consumption/company/${companyId}/msisdns?range=${range}&${msisdnQuery}`);;
}

export async function getMSISDNConsumption(companyId, range, msisdn)
{
      return await client.get(`v1/billing/report/consumption/company/${companyId}/msisdn/${msisdn}/?range=${range}`);;
}

export async function getBillingInfo(companyId)
{
    return await client.get(`/v1/billing/company/${companyId}`);;
}

export async function updateBillingInfo(companyId, settings)
{
    return await client.patch(`/v1/billing/company/${companyId}`, settings);;
}

export async function adjustBalance(companyId, data)
{
    return await client.post(`/v1/billing/balance/company/${companyId}`, data);;
}

export async function getTrialForCompany(companyId)
{
    return await client.get(`v1/trial/company/${companyId}`);
}

export async function getProjectsOfCompany(id)
{
    let response = await client.get(`v1/projects/company/${id}`);
    return response;
}

export async function updateCompany(companyId, company)
{
    return await client.put(`v1/company/${companyId}`, company)
}
export async function registerCompany(company)
{
    return await client.post('/v1/company', company)
}

export async function deleteCompany(companyId)
{
    return await client.delete(`v1/company/${companyId}`)
}

export async function getProjectForId(id)
{
    return await client.get(`v1/projects/${id}`);
}

export async function getGeofencesForCompany(id, page, size, search, includeEnlargement)
{
    return await client.get(`v1/geofence/company/${id}`, { params: { page: page, size: size, search: search, includeEnlargement: includeEnlargement }});
}

export async function getMultipleGeofences(ids, includeEnlargement)
{
    return await client.post(`v1/geofences`, ids, { params: { includeEnlargement: includeEnlargement }})
}

export async function createGeofenceForCompany(companyId, geofence)
{
    return await client.post(`v1/geofence/${companyId}`, geofence)
}

export async function updateProject(projectId, project)
{
    return await client.put(`v1/projects/${projectId}`, project)
}

export async function deleteGeofence(id)
{
    return await client.delete(`v1/geofence/${id}`)
}

export async function deleteProject(id)
{
    return await client.delete(`v1/projects/${id}`)
}

export async function createProject(companyId, name)
{
    const response = await client.post(`v1/projects/${companyId}`, {
        name: name
    })
    return response;
}

export async function patchGeofence(geofence)
{
    return await client.patch(`v1/geofence/${geofence.id}`, geofence)
}

//============= extras =============//

export async function addMsisdnExtra(extra, companyId)
{
    return await client.post(`v1/extras/msisdns/company/${companyId}`, extra)
}

export async function getMsisdnExtras(companyId)
{
    return await client.get(`v1/extras/msisdns/company/${companyId}`)
}

export async function deleteMsisdnExtra(extraKey, companyId)
{
    return await client.delete(`v1/extras/msisdns/company/${companyId}/${extraKey}`)
}

export async function updateMsisdnExtras(extras, companyId)
{
    return await client.put(`v1/extras/msisdns/company/${companyId}`, extras)
}

export async function updateGeofenceExtras(extras, companyId)
{
    return await client.put(`v1/extras/geofences/company/${companyId}`, extras)
}

export async function getGeofenceExtraKeys(companyId)
{
    return await client.get(`v1/extras/geofences/company/${companyId}`)
}
export async function deleteGeofenceExtra(extraKey, companyId)
{
    return await client.delete(`v1/extras/geofences/company/${companyId}/${extraKey}`)
}
export async function addGeofenceExtra(extra, companyId)
{
    return await client.post(`v1/extras/geofences/company/${companyId}`, extra)
}

export async function getGeofenceExtrasWithValues(geofenceIds)
{
    return await client.post(`v1/geofence/extras`, { ids: geofenceIds })
}

//============= Settings =============//
export async function getGlobalAppSettings()
{
    return await client.get(`/v1/settings/app/level/global`)
}

export async function getGlobalGeneralSettings()
{
    return await client.get(`/v1/settings/general/level/global`)
}

export async function updateGlobalAppSettings(settings)
{
    return await client.post(`/v1/settings/app/level/global`, settings)
}

export async function updateGlobalGeneralSettings(settings)
{
    return await client.post(`/v1/settings/general/level/global`, settings)
}

export async function getAppSettingsForCompany(companyId)
{
    return await client.get(`v1/settings/app/level/company/${companyId}`)
}

export async function updateAppSettingsForCompany(companyId, settings)
{
    return await client.post(`v1/settings/app/level/company/${companyId}`, settings)
}

export async function getGeneralSettingsForCompany(companyId, settings)
{
    return await client.get(`v1/settings/general/level/company/${companyId}`, settings)
}

export async function updateGeneralSettingsForCompany(companyId, settings)
{
    return await client.post(`v1/settings/general/level/company/${companyId}`, settings)
}

//============= Work Orders =============//

export async function getWorkOrdersForCompany(companyId, page)
{
    return await client.get(`v1/orders/company/${companyId}`, { params: { page: page }})
}

export async function getWorkOrdersForGeofences(geofences)
{
    return await client.get(`v1/orders/geofences`, { params: { geofences: geofences }})
}

export async function createWorkOrderForCompany(companyId, workOrder)
{
    return await client.post(`v1/orders/company/${companyId}`, workOrder)
}

export async function deleteWorkOrder(id)
{
    return await client.delete(`v1/orders/${id}`)
}

export async function putWorkOrderAssignments(workOrderId, assignments)
{
    return await client.put(`v1/orders/${workOrderId}/assignments`, assignments)
}

// Timeline Event categories

export async function getTimelineEventCategoriesForCompany(companyId, includeSystemCategories = false)
{
    return await client.get(`v1/timeline/categories/${companyId}`, { params: { includeSystemCategories }})
}

export async function addTimelineLocalization(categoryId, localization) {
    return client.post(
        `v1/timeline/categories/${categoryId}/localizations`,
        localization
    );
}

export async function deleteTimelineLocalization(categoryId, languageCode) {
    return client.delete(
        `v1/timeline/categories/${categoryId}/localizations/${languageCode}`
    );
}


export async function registerCustomTimelineEventCategory(companyId, category)
{
    return await client.post(`v1/timeline/categories/${companyId}`, category)
}

export async function deleteCustomTimelineEventCategory(categoryId)
{
    return await client.delete(`v1/timeline/categories/${categoryId}`)
}

export async function updateCustomTimelineEventCategory(categoryId, category)
{
    return await client.put(`v1/timeline/categories/${categoryId}`, category)
}

// Notifications

export async function getNotificationSubscriptionsForCompany(companyId)
{
    return await client.get(`v1/notifications/subscribers/company/${companyId}`)
}

export async function getGlobalNotificationSubscribers()
{
    return await client.get(`v1/notifications/subscribers/global`)
}

export async function subscribeToNotificationsForCompany(companyId, subscriber)
{
    return await client.post(`v1/notifications/subscribers/company/${companyId}`, subscriber)
}

export async function subscribeToGlobalNotifications(subscriber)
{
    return await client.post(`v1/notifications/subscribers/global`, subscriber)
}

export async function unsubscribeFromNotificationsForCompany(companyId, email)
{
    return await client.delete(`v1/notifications/subscribers/company/${companyId}/recipient/${email}`)
}

export async function unsubscribeFromGlobalNotifications(email)
{
    return await client.delete(`v1/notifications/subscribers/global/recipient/${email}`)
}